import React, { useEffect, useState } from "react"

const Card = (props) => {
  const [url,setUrl] = useState("");

  const openUrl = () => {
      var newWindow = window.open(url, '_blank');
      if (newWindow) {
        newWindow.focus();
      }
  };

  useEffect (()=>{
    if(props.title === "Celebrity List App") {
      setUrl("https://65808d3558f3e67e7f95b897--candid-klepon-88cf5d.netlify.app/");
    } else if(props.title === "Message Board") {
      setUrl("https://65819890112e260fe0e4a499--capable-concha-1b2cb5.netlify.app/");
    } else if(props.title === "Todo List App") {
      setUrl("https://65827d0d6e78fb348ec0dc3b--graceful-vacherin-914cca.netlify.app/");
    } else {
      setUrl("https://6580903e7a739801531d3f89--darling-froyo-1e3ee9.netlify.app/");
    }
  }, [props.title]);
  return (
    <>
      <div className='box btn_shadow ' onClick={openUrl}>
        <div className='img'>
          <img src={props.image} alt='Website screenshot' />
        </div>
        <div className='title'>
          <h2>{props.title}</h2>
          <a href='#popup' className='arrow'>
            <i class='fas fa-arrow-right'></i>
          </a>
        </div>
      </div>

    </>
  )
}

export default Card
